
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white">
      <div className="container mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 gap-12 mb-12">
          <div>
            <h3 className="text-2xl font-bold mb-6 text-amber-400" style={{ fontFamily: '"Noto Serif JP", serif' }}>
              株式会社eta
            </h3>
            <p className="text-gray-300 leading-relaxed" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
              〒413-0231<br />
              静岡県伊東市富戸877番地の4
            </p>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6 text-amber-400" style={{ fontFamily: '"Noto Serif JP", serif' }}>
              サイトマップ
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="#about" className="text-gray-300 hover:text-amber-400 transition-colors duration-300 flex items-center gap-2" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                  <i className="ri-arrow-right-s-line text-amber-500"></i>
                  会社概要
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-300 hover:text-amber-400 transition-colors duration-300 flex items-center gap-2" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                  <i className="ri-arrow-right-s-line text-amber-500"></i>
                  事業内容
                </a>
              </li>
              <li>
                <a href="#plan" className="text-gray-300 hover:text-amber-400 transition-colors duration-300 flex items-center gap-2" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                  <i className="ri-arrow-right-s-line text-amber-500"></i>
                  事業計画
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-300 hover:text-amber-400 transition-colors duration-300 flex items-center gap-2" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                  <i className="ri-arrow-right-s-line text-amber-500"></i>
                  お問い合わせ
                </a>
              </li>
              <li>
                <a href="/privacy" className="text-gray-300 hover:text-amber-400 transition-colors duration-300 flex items-center gap-2" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                  <i className="ri-arrow-right-s-line text-amber-500"></i>
                  プライバシーポリシー
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
              © {currentYear} 株式会社eta. All rights reserved.
            </p>
            
          </div>
        </div>
      </div>
    </footer>
  );
}
